<template>
  <Modal
    :is-open="isOpen"
    icon="pencil"
    title="Update Mileage"
    description="Enter the new mileage for this vehicle."
    :buttons="['close', 'ok']"
    close-text="Cancel"
    ok-text="Update"
    min-width="400"
    max-width="400"
    :is-confirming="isLoading"
    :disable-close="isLoading"
    @close-modal="$emit('close')"
    @ok-modal="$emit('save', mileageState.mileage)"
  >
    <FormGroup :label="`Current Mileage (${unit || 'miles'})`">
      <Input
        v-model="mileageState.mileage"
        type="number"
        :placeholder="currentMileage?.toString() || '0'"
        :min="0"
        :has-error="hasError"
      />
      <InputError :has-error="hasError">
        {{ errorMessage }}
      </InputError>
    </FormGroup>
  </Modal>
</template>

<script setup lang="ts">
// composables
import { reactive, watch } from 'vue'
// components
import Modal from '@/components/modal/Modal.vue'
import FormGroup from '@/components/forms/FormGroup.vue'
import Input from '@/components/forms/Input.vue'
import InputError from '@/components/forms/InputError.vue'

interface Props {
  isOpen: boolean
  isLoading: boolean
  currentMileage: number | null
  unit: string | null
  mileage: string | null
  hasError: boolean
  errorMessage: string | null
}

const props = defineProps<Props>()

const emit = defineEmits<{
  close: []
  save: [mileage: string | null]
  'update:mileage': [mileage: string | null]
}>()

const mileageState = reactive({
  mileage: props.mileage
})

watch(
  () => props.isOpen,
  isOpen => {
    if (isOpen) {
      mileageState.mileage = props.currentMileage != null ? String(props.currentMileage) : null
    }
  }
)

watch(
  () => mileageState.mileage,
  newValue => {
    emit('update:mileage', newValue)
  }
)
</script>
